import { createHook } from '../index.tsx';
import { getCallbacks } from './callbacks.tsx';

export const useCallbacks = createHook(getCallbacks);
